import { render, staticRenderFns } from "./AdminSettingSsoMapping.vue?vue&type=template&id=5a4deaf9&scoped=true&"
import script from "./AdminSettingSsoMapping.vue?vue&type=script&lang=js&"
export * from "./AdminSettingSsoMapping.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingSsoMapping.vue?vue&type=style&index=0&id=5a4deaf9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4deaf9",
  null
  
)

export default component.exports